var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429199,
    y: 0.15625,
    width: 25.2197,
    height: 25.2197,
    rx: 12.6099,
    fill: "#FBEACE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 13.9443C13.5986 13.9443 14.5287 13.0141 14.5287 11.8667C14.5287 10.7192 13.5986 9.78906 12.4511 9.78906C11.3037 9.78906 10.3735 10.7192 10.3735 11.8667C10.3735 13.0141 11.3037 13.9443 12.4511 13.9443Z",
    fill: "#F67474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 18.3719C8.57129 16.231 10.3063 14.4922 12.451 14.4922C14.5956 14.4922 16.3306 16.2272 16.3306 18.3719",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.46bfb4e92138d3ca1e9b07fd7185e8b7.svg";
export { ForwardRef as ReactComponent };